export default __webpack_public_path__ + "static/media/bannerFooter.0f64261f.png";